import { Theme } from '@mui/material/styles';
import { tabClasses } from '@mui/material/Tab';

import { deepNavy } from '../../palette-v2';

// ----------------------------------------------------------------------
// V2 Design System — Tabs
//
// These are the primary page-level navigation (SectionLayout's TabList, used by
// 11 pages across both products). The v1 override separated the selected and
// unselected states by a single adjacent step — selected `primary.dark`
// (deepNavy 700) vs unselected `text.secondary` (deepNavy 500) — which read as
// "nothing is selected". Selected now goes to the darkest step and carries the
// heavier weight, leaving the unselected tabs clearly recessive.
// ----------------------------------------------------------------------

export function tabsV2(theme: Theme) {
  return {
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: deepNavy[900],
          height: 2,
          borderRadius: 2,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: deepNavy[900],
          textTransform: 'none' as const,
          fontWeight: theme.typography.fontWeightSemiBold,
          [`&.${tabClasses.selected}`]: {
            color: deepNavy[900],
            fontWeight: theme.typography.fontWeightSemiBold,
          },
          [`&:not(.${tabClasses.selected})`]: {
            color: deepNavy[500],
            fontWeight: theme.typography.fontWeightMedium,
            '&:hover': {
              color: deepNavy[700],
            },
          },
          [`&.${tabClasses.disabled}`]: {
            color: deepNavy[300],
          },
        },
      },
    },
  };
}
